module.exports = __webpack_public_path__ + "static/media/map-outline-01.d5c592d9.svg";